import { Button, Text, Stack, Center, Box } from "@mantine/core";
import { useEffect } from "react";
import { useAuth } from "../authentication/AuthProvider";
import { Logo } from "../shared/components/Logo";

const LoggedOff = () => {
  const { signOut } = useAuth();

  useEffect(() => {
    signOut();
  }, []);

  return (
    <Center style={{ height: "100vh" }}>
      <Stack align="center" justify="center" gap="sm">
        <Box w={100}>
          <Logo />
        </Box>
        <Text size="lg">You are logged out of Early Bird RSVP</Text>
        <Button
          mt="md"
          style={{ width: "250px" }}
          onClick={() => {
            // This causes a refresh of the page, which will clear state
            window.location.href = "/login";
          }}
        >
          To log in again click here
        </Button>
      </Stack>
    </Center>
  );
};

export default LoggedOff;
